import * as yup from "yup";

const moneySchema = yup.object({
  amount: yup.string().required("Debes ingresar un monto"),
  currency: yup.string().required(),
});

export default moneySchema;
